import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ComingSoon from './components/ComingSoon';

// Service Pages
import Landing from './pages/Landing';
import RentCollectionAndAccounting from './pages/RentCollectionAndAccounting';
import TenantManagement from './pages/TenantManagement';
import PropertyManagement from './pages/PropertyManagement';
import Assessment from './pages/Assessment';
import MRIandFiling from './pages/MRIandFiling';
import PropertyMarketing from './pages/PropertyMarketing';
import ProjectManagement from './pages/ProjectManagement';

// Other Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Pricing from './pages/Pricing';
import Project from './pages/Project';
import Tenants from './pages/Tenants';
import Properties from './pages/Properties';
import AdminDashboard from './pages/AdminDashboard';
import ManagerDashboard from './pages/ManagerDashboard';
import UserDashboard from './pages/UserDashboard';
import AboutUs from './pages/AboutUs';
import CommunityBlog from './pages/CommunityBlog';
import Article from './pages/Article';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AdminEmails from './pages/AdminEmails';
import AdminContacts from './pages/AdminContacts';

// Configure a theme with enhanced z-index values
const theme = createTheme({
  zIndex: {
    appBar: 1200,
    drawer: 1300,
    modal: 1400,
    snackbar: 1500,
    tooltip: 1600,
  },
});

// Footer wrapper component to conditionally render Footer
const FooterWrapper = () => {
  const location = useLocation();
  // Don't show footer on the contact page
  if (location.pathname === '/contact') {
    return null;
  }
  return <Footer />;
};

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  // Detect if we're on the admin subdomain
  const isAdminDomain = window.location.hostname.startsWith('admin.');
  
  // Check authentication status
  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      setIsAuthenticated(true);
    }
    
    setIsLoading(false);
  }, []);
  
  if (isLoading) {
    return <div>Loading...</div>;
  }
  
  // Admin requires authentication
  if (isAdminDomain && !isAuthenticated) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login adminMode={true} />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    );
  }
  
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
      <Navbar />
      <Routes>
          {isAdminDomain ? (
            // Admin routes
            <>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/manager" element={<ManagerDashboard />} />
        <Route path="/user" element={<UserDashboard />} />
              <Route path="/admin-emails" element={<AdminEmails />} />
              <Route path="/admin-emails/compose" element={<AdminEmails />} />
              <Route path="/admin-emails/view/:id" element={<AdminEmails />} />
              <Route path="/admin-contacts" element={<AdminContacts />} />
              <Route path="/admin-contacts/view/:id" element={<AdminContacts />} />
              <Route path="/rent-collection" element={<RentCollectionAndAccounting />} />
              <Route path="/tenant-management" element={<TenantManagement />} />
              <Route path="/property-management" element={<PropertyManagement />} />
              <Route path="/assessment" element={<Assessment />} />
              <Route path="/mri-filing" element={<MRIandFiling />} />
              <Route path="/property-marketing" element={<PropertyMarketing />} />
              <Route path="/project-management" element={<ProjectManagement />} />
              <Route path="/coming-soon" element={<ComingSoon pageName="Coming Soon" />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/project" element={<Project />} />
              <Route path="/tenants" element={<Tenants />} />
              <Route path="/properties" element={<Properties />} />
              <Route path="/article/:id" element={<Article />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            // Main website routes
            <>
              <Route path="/" element={<Landing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/community-blog" element={<CommunityBlog />} />
        <Route path="/admin-login" element={<Login adminMode={true} />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin-emails" element={<AdminEmails />} />
        <Route path="/admin-emails/compose" element={<AdminEmails />} />
        <Route path="/admin-emails/view/:id" element={<AdminEmails />} />
        <Route path="/admin-contacts" element={<AdminContacts />} />
        <Route path="/admin-contacts/view/:id" element={<AdminContacts />} />
        <Route path="/rent-collection" element={<RentCollectionAndAccounting />} />
        <Route path="/tenant-management" element={<TenantManagement />} />
        <Route path="/property-management" element={<PropertyManagement />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/mri-filing" element={<MRIandFiling />} />
        <Route path="/property-marketing" element={<PropertyMarketing />} />
        <Route path="/project-management" element={<ProjectManagement />} />
        <Route path="/coming-soon" element={<ComingSoon pageName="Coming Soon" />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/project" element={<Project />} />
        <Route path="/tenants" element={<Tenants />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/article/:id" element={<Article />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          )}
      </Routes>
      <FooterWrapper />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
